<template>
    <!-- 添加物模型 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item prop="function_type">
            <template slot="label">
              <span class="required">*</span>
              <span>功能类型
                <v-col :offset="1" :span="2" class="contents">
                    <v-tooltip
                      class="v-tooltip-top"
                      :max-width="310"
                      content="属性一般是设备的运行状态，如当前温度等；服务是设备可被调用的方法，支持定义参数，如执行某项任务；事件则是设备上报的通知，如告警，需要被及时处理。"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
              </span>
            </template>
            <v-radio class="options" @change="typeChange" v-model="ruleForm.function_type" name="functionType" :options="functionTypeOptions"></v-radio>
          </v-form-item>
          <v-form-item  prop="name" key="name">
            <template slot="label">
              <span class="required">*</span>
              <span>功能名称</span>
            </template>
            <v-input type="text" name="name" v-model="ruleForm.name"></v-input>
          </v-form-item>
          <v-form-item  prop="identifier" key="identifier">
            <template slot="label">
              <span class="required">*</span>
              <span>标识符</span>
            </template>
            <v-input type="text" name="identifier" v-model="ruleForm.identifier"></v-input>
          </v-form-item>
          <v-form-item prop="data_type"  v-if="ruleForm.function_type == 'properties'" key="data_type">
            <template slot="label">
              <span class="required">*</span>
              <span>数据类型</span>
            </template>
            <v-select id="data_type" insertContains="data_type" name="data_type" v-model="ruleForm.data_type" :options="dataTypeOptins"></v-select>
          </v-form-item>

          <!-- <v-form-item prop="unit" :required="false" v-if="ruleForm.function_type == 'properties'" key="unit">
            <template slot="label">
              <span class="required"></span>
              <span>单位</span>
            </template>
            <v-input type="text" name="unit" v-model="ruleForm.unit"></v-input>
          </v-form-item> -->

          <v-form-item prop="input_data" :required="false"  v-if="ruleForm.function_type == 'service'" key="input_data">
            <template slot="label">
              <span class="required"></span>
              <span>输入参数</span>
              <div class="handle-button"><v-button size="S" type="text" name="btn12" @click="openAddModel('input')">+增加参数</v-button></div>
            </template>
              <div v-for="(item,index) in ruleForm.input_data" :key="index">
                <div class="parameter mb10" ><span>{{ item.identifier }}：{{item.name}}</span></div>
                <span class="parame-edit-del">
                  <span class="handle-button"><v-button size="S" type="text" name="btn3" slot="reference" @click="openUpdateModel(item, index, 'input')">编辑</v-button></span>
                  <span class="handle-button"><v-button size="S" type="text" name="btn4" slot="reference" @click="delParam(index,'input')">删除</v-button></span>
                </span>
              </div>
          </v-form-item>

          <v-form-item prop="output_data" :required="false" v-if="ruleForm.function_type != 'properties'" key="output_data">
            <template slot="label">
              <span class="required"></span>
              <span>输出参数</span>
              <div class="handle-button"><v-button size="S" type="text" name="btn2" @click="openAddModel('output')">+增加参数</v-button></div>
            </template>
            <div v-for="(item,index) in ruleForm.output_data" :key="index">
              <div class="parameter mb10" ><span>{{ item.identifier }}：{{item.name}}</span></div>
              <span class="parame-edit-del">
                <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="openUpdateModel(item, index, 'output')">编辑</v-button></span>
                <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="delParam(index,'output')">删除</v-button></span>
              </span>
            </div>
          </v-form-item>

          <v-form-item  prop="desc" :required="false" key="desc">
            <template slot="label">
              <span class="required"></span>
              <span>备注</span>
            </template>
            <v-input type="textarea" class="Description" name="desc" :maxlength="200" show-word-limit v-model="ruleForm.desc"></v-input>
          </v-form-item>
        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>
      </v-dialog>
      <AddParam  :showInputDialog.sync="addloading" ref="add" @changeinputDataList="changeinputDataList" :ParamData="ParamData"></AddParam>
      <UpdateParam  :updataOrview="updataOrview" :showInputDialog.sync="Updateloading" ref="Update" :propData="propData" :ParamData="ParamData" :updateIndex="updateIndex" @updatainputDataList="updatainputDataList"></UpdateParam>
    </div>

</template>

  <script>
import { copy } from '@/common/libs/utils';
import AddParam from "@/components/product/physicalmodel/add-param.vue";
import UpdateParam from "@/components/product/physicalmodel/updata-param.vue";

  export default {
    components: {AddParam, UpdateParam},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      productKey:{},
      productId:{},
    },
    data() {
      return {
        dialogTitle: "添加自定义功能",
        updataOrview: 1,
        rules: {
          name: copy([{
            type: "nameInput"
          }]),
          identifier: copy([{
            type: "identifier"
          }]),
        },
        ruleForm:{
          function_type: 'properties',   //功能类型：PROPERTIES 属性；EVENT 事件；SERVICE 服务
          name: '',     //名称
          identifier: '',  //标识
          desc: '',   //备注
          data_type:'',
          // unit:'',
          input_data:[],
          output_data:[]
        },

        functionTypeOptions:[
            {
              label: "属性",
              value: 'properties'
            },
            {
              label: "服务",
              value: 'service'
            },
            {
              label: "事件",
              value: 'event'
            }
        ],
        dataTypeOptins:[
          {
              label: "int(整数)",
              value: 'int'
          },
          {
              label: "float64(浮点数)",
              value: 'float64'
          },
          {
              label: "string(字符串)",
              value: 'string'
          },
          {
              label: "bool(布尔值)",
              value: 'bool'
          },
          {
              label: "array(数组)",
              value: 'array'
          },
          {
              label: "struct(结构)",
              value: 'struct'
          }
        ],

        addloading:false,
        Updateloading: false,
        isShow:false,
        updateIndex: 0,
        propData:{},
        ParamData: [],
        originalData:{},
        function_type1:'',
        upTips:true,
        datatype:'',
      };
    },
    created() {
      this.originalData = copy(this.ruleForm)
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      },
    },
    methods: {
      open(){},
      typeChange(value){
        if(this.function_type1 != value){
          this.ruleForm = copy(this.originalData)
          this.ruleForm.function_type = value
        }
        this.function_type1 = value
      },
      openAddModel(type){
        this.datatype = type
        this.ParamData = type == 'input' ?  this.ruleForm.input_data : this.ruleForm.output_data
        this.addloading = !this.addloading
      },
      openUpdateModel(data,index, type){
        this.datatype = type
        this.propData = data
        this.updateIndex = index
        this.ParamData = type == 'input' ?  this.ruleForm.input_data : this.ruleForm.output_data
        this.Updateloading = !this.Updateloading
      },
      changeinputDataList(data){
        if(this.datatype == 'input'){
          let list = copy(this.ruleForm.input_data)
          list.push(data)
          this.ruleForm.input_data = copy(list)
        }else{
          let list = copy(this.ruleForm.output_data)
          list.push(data)
          this.ruleForm.output_data = copy(list)
        }
      },
      updatainputDataList(data,index){
        if(this.datatype == 'input'){
          let list = copy(this.ruleForm.input_data)
          list.splice(index, 1 , data)
          this.ruleForm.input_data = copy(list)
        }else{
          let list = copy(this.ruleForm.output_data)
          list.splice(index, 1 , data)
          this.ruleForm.output_data = copy(list)
        }
      },
      delParam(index ,type){
        if(type == 'input'){
          this.ruleForm.input_data.splice(index, 1)
        }else{
          this.ruleForm.output_data.splice(index, 1)
        }
      },
      handleConfirm() {
        // if (this.ruleForm.input_data.length == 0 && this.ruleForm.function_type == 'service') {
        //   this.$message.error("请检查输入参数")
        //   return
        // }
        // if (this.ruleForm.output_data.length == 0 && this.ruleForm.function_type != 'properties') {
        //   this.$message.error("请检查输出参数")
        //   return
        // }
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        let submitData = { ...this.ruleForm };
        submitData.product_id = Number(this.productId)
        submitData.product_key = this.productKey
        submitData.model_type = "PRODUCT"
        this.$post("/td/td-iot-api/iot/thing/draft/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
